import { useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { ArrowLeft, Send, CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import Navbar from "../components/Navbar";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error("Please fill in all fields");
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.post(`${API}/contact`, form);
      setSubmitted(true);
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to submit query");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <Navbar />

      <div className="max-w-2xl mx-auto px-6 md:px-12 py-12">
        {submitted ? (
          <div className="text-center py-20 animate-fade-in" data-testid="contact-success">
            <div className="w-16 h-16 rounded-full bg-[#20C997]/10 flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={32} className="text-[#20C997]" />
            </div>
            <h1 className="font-['Cormorant_Garamond'] text-4xl font-light text-[#1A1B1A]">
              Thank You
            </h1>
            <p className="text-[#5C5D5C] mt-4">
              We've received your query and will get back to you within 24 hours.
            </p>
            <Link to="/" className="inline-block mt-8 text-[#20C997] hover:underline font-medium">
              Return to Home
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-[#1A1B1A] mb-2">
              Contact Us
            </h1>
            <p className="text-[#5C5D5C] font-light mb-8">
              Have a question or need help? Send us a message and we'll respond within 24 hours.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
              <div>
                <label className="text-sm font-medium text-[#1A1B1A] mb-2 block">Your Name</label>
                <Input
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Full name"
                  className="rounded-none border-[#EAE6DF] h-12"
                  required
                  data-testid="contact-name"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-[#1A1B1A] mb-2 block">Email Address</label>
                <Input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="you@example.com"
                  className="rounded-none border-[#EAE6DF] h-12"
                  required
                  data-testid="contact-email"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-[#1A1B1A] mb-2 block">Subject</label>
                <Input
                  value={form.subject}
                  onChange={(e) => setForm({ ...form, subject: e.target.value })}
                  placeholder="How can we help?"
                  className="rounded-none border-[#EAE6DF] h-12"
                  required
                  data-testid="contact-subject"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-[#1A1B1A] mb-2 block">Message</label>
                <Textarea
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Tell us more about your enquiry..."
                  className="rounded-none border-[#EAE6DF] min-h-[150px]"
                  required
                  data-testid="contact-message"
                />
              </div>
              <Button
                type="submit"
                disabled={submitting}
                className="w-full bg-[#20C997] hover:bg-[#1AAE82] text-white rounded-none py-6 text-base font-medium"
                data-testid="contact-submit"
              >
                <Send size={18} className="mr-2" />
                {submitting ? "Sending..." : "Send Message"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
